import { CompanionError } from '../_internal/error/CompanionError';
import { getCachedSession } from '../session/cache';
import { emitEvent } from '../utils/events/module';
import { findSite } from './util';
let currentSiteId;
export function clearCurrentSiteId() {
    // Clear local state
    currentSiteId = undefined;
    emitEvent('site', 'currentSiteIdChanged', undefined);
}
/**
 * Set the current site id.
 *
 * If the user's 'default site' preference is set to 'recent', this function will also update the cookie.
 */
export function setCurrentSiteId(siteId) {
    const session = getCachedSession();
    if (!session) {
        throw new CompanionError({
            error: new Error('Invalid session!'),
            code: 'SESSION_INVALID',
        });
    }
    // Find site by id
    const foundSite = findSite(siteId, session.sites);
    // Update local state
    currentSiteId = foundSite.site_id;
    emitEvent('site', 'currentSiteIdChanged', currentSiteId);
}
setCurrentSiteId.ERR = {
    SESSION_INVALID: 'SESSION_INVALID',
};
/**
 * Get the site id that needs to be set after creating a session.
 *
 * Will try to get siteId from default property user setting in the session object.
 * Otherwise defaults to the `default_site` property in the session object.
 *
 * If default property is set to "recent" will try to grab siteId from the cookie.
 * If it can't find that siteId it will remove the cookie.
 */
export function getInitialCurrentSiteId(session) {
    const siteId = findSite(session.default_site, session.sites).site_id;
    return siteId;
}
/**
 * Get the current site id or undefined if no site has been set.
 */
export function getCurrentSiteId() {
    return currentSiteId;
}
export function getCurrentSiteIdOrThrow() {
    if (typeof currentSiteId === 'undefined') {
        throw new CompanionError({
            error: new Error('No current site id set!'),
            code: 'SITE_ID_MISSING',
        });
    }
    return currentSiteId;
}
getCurrentSiteIdOrThrow.ERR = {
    SITE_ID_MISSING: 'SITE_ID_MISSING',
};
